import React, { useEffect } from 'react';
import styles from './index.module.scss';
import AppLayout from '../../layout/AppLayout';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import CategoryFilters from './components/CategoryFilters';
import OffersList from './components/OffersList';
import ACTION_TYPES from '../../store/actionTypes.constants';
import { getUrlFilters, useParsedUrlFilters } from './offers.utils';
import { useNavigateRoute } from '../../hooks/custom.hooks';
import { useAllOffers } from '../../api/api.calls';

function OffersPage() {
  // const platforms = useSelector(({ appReducer }) => appReducer.platforms);
  const appliedFilters = useSelector(
    ({ appReducer }) => appReducer.appliedFilters,
    shallowEqual,
  );
  const { platform = 'all' } = appliedFilters || {};
  const dispatch = useDispatch();

  let parsedFilters = useParsedUrlFilters(); // Get filters from hook

  // Check if 'offer_value' is NOT present in parsedFilters
  if (!('offer_value' in parsedFilters)) {
    parsedFilters = {
      ...parsedFilters,
      offer_value: ['0'],
    };
  }
  const { data: apiResponse, isLoading, refetch } = useAllOffers();

  useEffect(() => {
    // REMOVED by @AKASH
    // if (!isObjectEmpty(parsedFilters)) {
    dispatch({
      type: ACTION_TYPES.APPLIED_FILTERS,
      payload: parsedFilters,
    });
    // }
  }, [dispatch, parsedFilters]);

  const navigateRoute = useNavigateRoute();
  return (
    <AppLayout
      showLogo={true}
      gobackAction={() => {
        navigateRoute({ goBack: true });
      }}
      customHeader={() => {
        // @todo move this to a component
        return (
          <div className={styles.offerHeader}>
            <div
              className={styles.left}
              onClick={() => {
                navigateRoute({ nextPage: '/home' });
              }}
            >
              All Offers
            </div>
            <div className={styles.right}>
              {[].map((entry) => {
                return (
                  <div
                    className={`${styles.platform} ${
                      platform === entry.id ? styles.selectedPlat : null
                    }`}
                    key={entry.id}
                    onClick={() => {
                      const payload = {
                        ...appliedFilters,
                        platform: entry.id,
                      };
                      dispatch({
                        type: ACTION_TYPES.APPLIED_FILTERS,
                        payload,
                      });
                      const urlFilters = getUrlFilters(payload);
                      navigateRoute({ nextPage: `/?${urlFilters}` });
                    }}
                  >
                    {entry.id}
                  </div>
                );
              })}
            </div>
          </div>
        );
      }}
    >
      <div
        className={styles.offers}
        // style={{
        //   top:
        //     document.getElementById('appHeaderMain')?.clientHeight - 0.5 || 116,
        // }}
      >
        <CategoryFilters data={apiResponse} />
      </div>
      <div className={styles.offersList}>
        <OffersList
          apiResponse={apiResponse}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
    </AppLayout>
  );
}

export default OffersPage;
